import { combineReducers } from 'redux';
import { boundaryCreateOptimizedReducer } from '~/store/frontendState/mapTools/boundary/boundaryCreateOptimized/boundaryCreateOptimized.reducer';
import { boundaryCreateWMSOptimizedReducer } from '~/store/frontendState/mapTools/boundary/boundaryCreateWMSOptimized/boundaryCreateWMSOptimized.reducer';
import { boundarySidebarStateReducer } from '~/store/frontendState/mapTools/boundary/boundarySidebarState/boundarySidebarState.reducer';
import { boundaryDrawReducer } from './boundaryDraw/boundaryDraw.reducer';
import { boundaryFormReducer } from './boundaryForm/boundaryForm.reducer';
import { boundaryHighlightReducer } from './boundaryHighlight/boundaryHighlight.reducer';
import { boundaryPolygonUpdateReducer } from './boundaryPolygonUpdate/boundaryPolygonUpdate.reducer';
import { boundaryRenderingReducer } from './boundaryRendering/boundaryRendering.reducer';
import { boundarySelectReducer } from './boundarySelect/boundarySelect.reducer';
import { convertBoundariesReducer } from './convertBoundaries/convertBoundaries.reducer';

export const boundaryToolStateReducer = combineReducers({
  boundaryHighlight: boundaryHighlightReducer,
  boundarySelect: boundarySelectReducer,
  boundaryDraw: boundaryDrawReducer,
  convertBoundaries: convertBoundariesReducer,
  boundaryRendering: boundaryRenderingReducer,
  boundaryPolygonUpdate: boundaryPolygonUpdateReducer,
  boundaryCreateWMSOptimized: boundaryCreateWMSOptimizedReducer,
  boundaryCreateOptimized: boundaryCreateOptimizedReducer,
  boundaryForm: boundaryFormReducer,
  boundarySidebarHighlight: boundarySidebarStateReducer,
});
